export default __webpack_public_path__ + "static/media/personal@2x.efbb962b.png";